// CodeExamples
export {CodeBlock} from "./code-examples/CodeBlock";
export {CodeBlockToolbar} from "./code-examples/CodeBlockToolbar";
export {CodeExample} from "./code-examples/CodeExample";
export {CodeExampleSimple} from "./code-examples/CodeExampleSimple";

// KTCodeExamples
export {KTCodeBlock} from "./code-examples-kt/KTCodeBlock";
export {KTCodeExample} from "./code-examples-kt/KTCodeExample";

// Forms
export {DatePickerField} from "./forms/DatePickerField";
export {FieldFeedbackLabel} from "./forms/FieldFeedbackLabel";
export {FormAlert} from "./forms/FormAlert";
export {Input} from "./forms/Input";
export {Select} from "./forms/Select";
export {SearchSelect} from "./forms/Select";

export {Checkbox} from "./forms/Checkbox";
export {HeaderCheckbox} from "./forms/HeaderCheckbox";


// Paginations
export {Pagination} from "./pagination/Pagination"
export {PaginationLinks} from "./pagination/PaginationLinks";
export {PaginationToolbar} from "./pagination/PaginationToolbar";

// Controls
export * from "./Card";
export {default as AnimateLoading} from "./AnimateLoading";
export {LoadingDialog} from "./LoadingDialog";
export {Notice} from "./Notice";
export {SplashScreen} from "./SplashScreen";
export {SVGIcon} from "./SVGIcon";
export {ModalProgressBar} from "./ModalProgressBar";
export const prepareOptions = (labelProp, valueProp, options) => {
    const newOptions = options.map((option) => {
      return { label: option[labelProp] ?? option, value: option[valueProp] ?? option };
    });
    return newOptions;
  };
